export default __webpack_public_path__ + "static/media/new-session.14603479.svg";